module.exports = __webpack_public_path__ + "img/procedural-terrain1.0df36a6f.png";